import React, { useState, useEffect } from 'react';
import { Card, ProgressBar } from 'react-bootstrap';

const EnvironmentalImpact = ({ impact }) => {
    // Llamar siempre useState fuera de cualquier condición
    const [animatedScore, setAnimatedScore] = useState(0);

    // Animación de la barra de progreso
    useEffect(() => {
        if (impact) { // Asegurarse de que impact esté disponible antes de aplicar la animación
            setAnimatedScore(0); // Iniciar con 0
            const timer = setTimeout(() => {
                const interval = setInterval(() => {
                    setAnimatedScore((prev) => {
                        if (prev < impact.score * 10) {
                            return prev + 0.5; // Controlar la velocidad del incremento
                        } else {
                            clearInterval(interval);
                            return impact.score * 10;
                        }
                    });
                }, 20); // Intervalo de tiempo entre incrementos
                return () => clearInterval(interval);
            }, 300); // Retraso antes de iniciar la animación
            return () => clearTimeout(timer);
        }
    }, [impact]); // Dependencia de impact

    // Si impact no está disponible, no renderizamos nada
    if (!impact) return null;

    const color = impact.score >= 8 ? 'success' : impact.score >= 5 ? 'warning' : 'danger';
    const progressVariant = color;

    return (
        <Card className="clean-card shadow-sm mb-4">
            <div className="card-header">
                <h4 className="mb-0">
                    <span className="environmental-icon">🌿</span> Environmental Impact
                </h4>
            </div>
            <Card.Body>
                <div className="impact-score">
                    <p className={`score-text text-${color}`}>
                        <strong>Score:</strong> {impact.score}/10
                    </p>
                    <ProgressBar
                        now={animatedScore}
                        label={`${Math.round(animatedScore)}%`}
                        variant={progressVariant}
                        className="mb-3"
                    />
                </div>
                <p className="impact-description">{impact.description}</p>
            </Card.Body>
        </Card>
    );
};

export default EnvironmentalImpact;
